import dynamic from 'next/dynamic';
import React from 'react';
import { isCurrentPageJobSearch } from '~/jobiqo/components/Job/Detail/utils';
import { Job } from '~/jobiqo/types/types';

const BookmarkedJobsProvider = dynamic(
  import('~/jobiqo/components/BookmarkedJobs/context'),
);

interface JobDetailBookmarkWrapperProps {
  /**
   * The job entity.
   */
  job: Job;
  /**
   * The children nodes.
   */
  children: React.ReactNode;
}

const JobDetailBookmarkWrapper = ({
  job,
  children,
}: JobDetailBookmarkWrapperProps) =>
  isCurrentPageJobSearch() ? (
    <>{children}</>
  ) : (
    <BookmarkedJobsProvider initialState={job.bookmarked ? [job] : []}>
      {children}
    </BookmarkedJobsProvider>
  );

export default React.memo(
  JobDetailBookmarkWrapper,
  (prevProps, nextProps) => prevProps.job.id === nextProps.job.id,
);
